import { useSelector } from 'react-redux'
import {
  selectCurrentProject,
  selectPointsRecords,
  selectTaskSubmissions,
  selectXpRecords,
} from '../../modules/missionControl/selectors'
import { selectIsEthRaise } from '../../modules/web3/selectors'
import { wrapRewardDisplay } from '../../page_components/Home/useUpcomingProjects'
import styled from 'styled-components'
import { selectIsDrops } from '../../modules/miscUi/selectors'
import {
  UserProjectPoints,
  UserProjectXps,
} from '../../modules/missionControl/slice'

const getPoolTotalTaskPoints = (
  taskSubmissionsIds: number[],
  pointsRecords: UserProjectPoints[],
) => {
  const taskPoints = pointsRecords?.filter((pointsRecord) =>
    taskSubmissionsIds?.includes(Number(pointsRecord.attachmentId)),
  )
  const totalTaskPoints = taskPoints?.reduce(
    (acc, { amount }) => acc + amount,
    0,
  )
  return totalTaskPoints
}

const getDropTotalTaskPoints = (
  taskSubmissionsIds: number[],
  xpRecords: UserProjectXps[],
) => {
  const taskXps = xpRecords?.filter((xpRecord) =>
    taskSubmissionsIds?.includes(Number(xpRecord.taskSubmissionId)),
  )
  const totalTaskPoints = taskXps?.reduce(
    (acc, taskXp) => acc + taskXp['xp'],
    0,
  )

  return totalTaskPoints
}

export const useTaskVariableRewardProgress = ({
  taskId,
}: {
  taskId: number
}) => {
  const currentProject = useSelector(selectCurrentProject)
  const task = currentProject.tasks.find((task) => task.id === taskId)

  const taskSubmissions = useSelector(selectTaskSubmissions)
  const pointsRecords = useSelector(selectPointsRecords)
  const xpRecords = useSelector(selectXpRecords)
  const isDrops = useSelector(selectIsDrops)
  const subtaskId = task?.subtasks?.[0]?.id
  const taskSubmissionsIds = taskSubmissions?.[subtaskId]?.map(
    ({ submissionId }) => submissionId,
  )

  return isDrops
    ? getDropTotalTaskPoints(taskSubmissionsIds, xpRecords)
    : getPoolTotalTaskPoints(taskSubmissionsIds, pointsRecords)
}

const Text = styled.div`
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.brandPrimary};
  text-align: right;
`

const TaskVariableRewardProgress = ({
  taskId,
  rewardDisplay,
}: {
  taskId: number
  rewardDisplay?: string
}) => {
  const totalTaskPoints = useTaskVariableRewardProgress({ taskId })
  const isEthRaise = useSelector(selectIsEthRaise)
  const isDrops = useSelector(selectIsDrops)

  return (
    <Text>
      Earned <br />+
      {wrapRewardDisplay({
        value: totalTaskPoints,
        isEthRaise,
        rewardDisplay,
        isDrops,
      })}
    </Text>
  )
}

export default TaskVariableRewardProgress
